import React from 'react';
import PropTypes from 'prop-types';
import {Auth0Provider} from '@auth0/auth0-react';
import Config from 'hooks/config';
import {ROUTES} from 'constants/app-routes';
import {E2E_AUTH_MARKER} from 'common/auth/e2eAuthMarker';

import AuthAPISetupProvider from 'common/auth/AuthAPISetupProvider';

const AuthProviderWithHistory = ({history, children}) => {
    const onRedirectCallback = (appState) => {
        // Use the router's history module to replace the url
        history.replace(appState?.returnTo || window.location.pathname);
    };

    const redirectUri = `${window.location.origin}${Config.basename}${ROUTES.dashboard}`;

    // Default to the in-memory cache for every human session in every
    // environment. Only the Playwright harness sets the marker (never prod), so
    // it can seed ROPG tokens into localStorage for the SDK to read.
    const cacheLocation =
        !Config.isProduction &&
        typeof window !== 'undefined' &&
        window[E2E_AUTH_MARKER]
            ? 'localstorage'
            : 'memory';

    return (
        <Auth0Provider
            domain={Config.auth0Domain}
            clientId={Config.auth0ClientId}
            redirectUri={redirectUri}
            audience={Config.auth0V1APIAudience}
            cacheLocation={cacheLocation}
            onRedirectCallback={onRedirectCallback}
        >
            <AuthAPISetupProvider>{children}</AuthAPISetupProvider>
        </Auth0Provider>
    );
};

AuthProviderWithHistory.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object,
};

export default AuthProviderWithHistory;
